import React from "react";
import Image from "next/image";

import localFont from "next/font/local";
import PetTagButton from "@/components/petTag/button/PetTagButton";
import Community from "./Community";
import useGetPetTag from "hooks/useGetPetTag";

const Joyride = localFont({
  src: "../../../public/fonts/Joyride-W05-STD.otf",
});

function PetTagHero({ onClick }) {
  const { isLoading: isBuyTagLoading } = useGetPetTag();

  return (
    <section className="pet-tag-hero-bg relative">
      <div className="max-w-[1440px] mx-auto px-4 lg:px-[151px] pt-[43px]">
        <div className="flex items-center justify-between max-w-[900px] mx-auto">
          <div className="w-[90px] h-[104px] min-[400px]:w-[97px] min-[400px]:h-[112px] lg:w-[120px] lg:h-[140px] relative -rotate-[15deg] shadow-[0px_20px_45px_0px_#135FB7] rounded-[1.25rem]">
            <Image src="/assets/pet-tag/hero/hero-dog.png" alt="dog" fill />
          </div>

          <Image
            src="/assets/pet-tag/hero/Smart.svg"
            alt="smart"
            width={360}
            height={111}
            className="hidden md:block"
          />
          <div className="relative">
            <div className="absolute w-[1.75rem] h-[1.75rem] lg:w-[2rem] lg:h-[2rem] z-10 top-[0.75rem] -left-[0.25rem] rotate-[15deg]">
              <Image src="/assets/pet-tag/hero/heart.png" alt="Heart" fill />
            </div>
            <div className="w-[90px] h-[104px] min-[400px]:w-[97px] min-[400px]:h-[112px] lg:w-[120px] lg:h-[140px] relative shadow-[0px_20px_45px_0px_#135FB7] rounded-[1.25rem] rotate-[15deg]">
              <Image
                src="/assets/pet-tag/hero/hero-cat-heartless.png"
                alt="Cat"
                fill
              />
            </div>
          </div>
        </div>

        <div className="flex justify-center py-[8px]">
          <Image
            src="/assets/pet-tag/hero/Smart.svg"
            alt="smart"
            width={180}
            height={55.5}
            className="block md:hidden shrink-0"
          />
        </div>

        <div
          className={`${Joyride.className} flex justify-center items-center relative space-x-[30px] lg:space-x-[64px]`}
        >
          <h2 className="text-[60px] min-[400px]:text-[70px] lg:text-[140px] text-[#FFEA00] leading-none text-shadow">
            PET
          </h2>

          <h2 className="text-[60px] min-[400px]:text-[70px] lg:text-[140px] text-white leading-none z-10 text-shadow">
            TAG
          </h2>

          <article className="absolute -top-[20px] md:-top-[40px] left-[calc(50%-15px)] -translate-x-[calc(50%+15px)] md:left-[calc(50%-2rem)] lg:-translate-x-[calc(50%+2rem)]">
            <Image
              src="/assets/pet-tag/hero/image.png"
              alt="cat"
              width={350}
              height={350}
              className="block lg:hidden"
            />
            <Image
              src="/assets/pet-tag/hero/image.png"
              alt="cat"
              width={396}
              height={396}
              className="hidden lg:block"
            />
          </article>
        </div>

        <div className="flex flex-col md:flex-row  md:items-center md:justify-between mt-[100px]">
          <div>
            <h3 className=" text-2xl capitalize font-extrabold tracking-[0.48px] text-white mb-[20px]">
              Stay Connected, Stay Secure
            </h3>

            <article className="text-white leading-[32px] tracking-[0.3px] w-[359px] font-normal lining-nums text-base lg:text-[20px]">
              Every moment counts when your pet is out of sight. Our Smart Pet
              Tag ensures you&apos;re always just a scan or tap away from
              reuniting with your furry friend.
            </article>
          </div>

          <div className="py-[30px] md:py-0 flex justify-end">
            <Community />
          </div>
        </div>

        <div className="flex justify-center pb-[30px] lg:pb-[80px]">
          <PetTagButton onClick={onClick} isLoading={isBuyTagLoading} />
        </div>
      </div>
    </section>
  );
}

export default PetTagHero;
